"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-shadow */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const utils_3d_1 = require("~/components/Cad3d/utils/utils.3d");
const consts_1 = require("~/consts/consts");
const selectors_1 = require("~/store/selectors");
const ItemPropertiesWidget_scss_1 = __importDefault(require("../ItemPropertiesWidget.scss"));
function ItemPropertiesList({ itemProperties }) {
    const isImperial = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    if (!itemProperties || !itemProperties.length) {
        return null;
    }
    const groupedProperties = Object.entries(itemProperties.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr.property.name]: [...(acc[curr.property.name] ? acc[curr.property.name] : []), curr] })), {}));
    return (react_1.default.createElement(react_1.default.Fragment, null, groupedProperties.map(([propertyType, properties]) => {
        let property = '';
        let uom = '';
        if (properties.length > 1) {
            // eslint-disable-next-line no-return-assign
            properties.forEach((itemProperty) => (property += (property ? ', ' : '') + itemProperty.value));
        }
        else {
            const { value, unitOfMeasurement, measurementUnit } = properties[0];
            property = value;
            if (unitOfMeasurement) {
                uom = unitOfMeasurement.name;
            }
            if (unitOfMeasurement &&
                measurementUnit &&
                ((isImperial && measurementUnit.name === 'Metric') || (!isImperial && measurementUnit.name === 'Imperial'))) {
                property = (0, utils_3d_1.roundTo3)(Number(value) * consts_1.unitsConvertTable[unitOfMeasurement.name]).toString();
                uom = consts_1.unitsTable[unitOfMeasurement.name];
            }
        }
        return (react_1.default.createElement("div", { key: propertyType },
            react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default.subtitle },
                propertyType,
                uom ? `, ${uom.toLowerCase()}` : ''),
            react_1.default.createElement("div", null, property)));
    })));
}
exports.default = ItemPropertiesList;
